import RectSkeleton from "./RectSkeleton";

// A LEAVE CALENDER TABLE SKELETON COMPONENT
const TableSkeleton = ({ numColumns = 31, numRows = 5 }) => {
    return (
        <table
            className="leave-tracker-table"
            style={{ borderCollapse: 'collapse', width: '100%' }}
        >
            <thead>
                <tr style={{ backgroundColor: 'rgb(86 124 9)' }}>
                    <th
                        style={{
                            padding: 8,
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'rgb(86 124 9)',
                        }}
                    >
                        <RectSkeleton
                            width={100}
                            height={30}
                            style={{
                                backgroundColor: '#ccc',
                                borderRadius: 1,
                                margin: '4px 2px',
                            }}
                        />
                    </th>
                    {Array.from({ length: numColumns }).map((_, i) => (
                        <th key={i} style={{ padding: 8 }}>
                            <RectSkeleton
                                width={30}
                                height={30}
                                style={{
                                    backgroundColor: '#ccc',
                                    borderRadius: 1,
                                    margin: '4px 2px',
                                }}
                            />

                        </th>
                    ))}
                    <th style={{ padding: 8 }}>
                        <RectSkeleton
                            width={50}
                            height={30}
                            style={{
                                backgroundColor: '#ccc',
                                borderRadius: 1,
                                margin: '4px 2px',
                            }}
                        />

                    </th>
                </tr>
            </thead>
            <tbody>
                {Array.from({ length: numRows }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        <td className="leave-tracker-employee-cell" style={{ padding: 8 }}>
                            <RectSkeleton
                                width={100}
                                height={20}
                                style={{
                                    backgroundColor: '#ccc',
                                    borderRadius: 1,
                                    margin: '4px 2px',
                                }}
                            />
                        </td>
                        {Array.from({ length: numColumns }).map((_, colIndex) => (
                            <td key={colIndex} style={{ padding: 8 }}>
                                <RectSkeleton
                                    width={30}
                                    height={20}
                                    style={{
                                        backgroundColor: '#ccc',
                                        borderRadius: 1,
                                        margin: '4px 2px',
                                    }}
                                />
                            </td>
                        ))}
                        <td className="leave-tracker-employee-cell" style={{ padding: 8 }}>
                            <RectSkeleton
                                width={50}
                                height={20}
                                style={{
                                    backgroundColor: '#ccc',
                                    borderRadius: 1,
                                    margin: '4px 2px',
                                }}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableSkeleton;
